/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ProductAddedNotification.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : SandeepRaja (E807238)
 *
 * @Date         : Nov 1, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : 06 Apr 2020
 * Description   : ASDS-2190 - API error handling changes. Handled Add to cart failure scenario.
 *
 * By            : H422336
 * On            : 01 Oct 2020
 * Description   : ASDS-3258 - UI Enhancement Phase II.
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2
 *
 ******************************************************************************/

import * as React from 'react';
import { Grid } from '@scuf/common';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import './ProductAddedNotification.css';
import ToastNotification from './ProductToastNotification';
import RouteConstants from '../constants/route-constants';
import  ProductUpdateToastNotification from './ProductUpdateToastNotification';

interface ProductAddedNotificationProps {
  productCtg: string;
  isAddToCartSuccess: boolean;
}

const ReactToastify =  require('react-toastify');

class ProductAddedNotification extends React.Component<ProductAddedNotificationProps & RouteComponentProps> {
  constructor(props: ProductAddedNotificationProps & RouteComponentProps) {
    super(props);
  }

  notify(value: boolean) {
    if(this.props.location.pathname === RouteConstants.PURCHASE_SOFTWARE){
    ReactToastify.toast(<ToastNotification success={value} productCtg={this.props.productCtg} closeToast={false}/>);
    }
    else {
      ReactToastify.toast(<ProductUpdateToastNotification success={value} productCtg={this.props.productCtg} closeToast={false}/>);
    }
  }

  render() {
    this.notify(this.props.isAddToCartSuccess);

    return (
      <Grid.Row>
        <Grid.Column width={12}>
          <div className='product-added-notification'>
            <ReactToastify.ToastContainer
              hideProgressBar={true}
              closeOnClick={false}
              closeButton={false}
              newestOnTop={true}
              position="bottom-right"
              toastClassName="toast-notification-wrap"
            />
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default connect()(withRouter(ProductAddedNotification));
